var _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5682 4.94318V3.40909C10.5682 3.00222 10.4066 2.61202 10.1189 2.32432C9.83116 2.03663 9.44096 1.875 9.03409 1.875H3.40909C3.00222 1.875 2.61202 2.03663 2.32432 2.32432C2.03663 2.61202 1.875 3.00222 1.875 3.40909V9.03409C1.875 9.44096 2.03663 9.83116 2.32432 10.1189C2.61202 10.4066 3.00222 10.5682 3.40909 10.5682H4.94318M10.5682 4.94318H11.5909C11.9978 4.94318 12.388 5.10481 12.6757 5.39251C12.9634 5.6802 13.125 6.07041 13.125 6.47727V11.5909C13.125 11.9978 12.9634 12.388 12.6757 12.6757C12.388 12.9634 11.9978 13.125 11.5909 13.125H6.47727C6.07041 13.125 5.6802 12.9634 5.39251 12.6757C5.10481 12.388 4.94318 11.9978 4.94318 11.5909V10.5682M10.5682 4.94318H6.47727C6.07041 4.94318 5.6802 5.10481 5.39251 5.39251C5.10481 5.6802 4.94318 6.07041 4.94318 6.47727V10.5682",
    stroke: "current",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.29688,
    y1: 7.70312,
    x2: 11.2188,
    y2: 7.70312,
    stroke: "current",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9.8125,
    x2: 10.5156,
    y2: 9.8125,
    stroke: "current",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6382ab5fe9dd245e4b42c8f31d392df2.svg";
export { ForwardRef as ReactComponent };